import { useEffect } from 'react';

export function useOnMount(fn: () => void) {
  useEffect(() => fn(), []);
}
